import React from 'react'
import { Table } from 'antd'

const TableView = ({ columns, dataSource, paginationConfig, rowKey = '_id', ...tableProps }) => {
  return <Table rowKey={(record) => record[rowKey]} columns={columns} dataSource={dataSource} pagination={paginationConfig} {...tableProps} />
}
export default TableView
